const STORAGE_KEYS = {
  CATEGORY: 'scanner_category',
};

export const categoryStorage = {
  //Сохранить категорию
  setCategory(categorySlug) {
    try {
      localStorage.setItem(STORAGE_KEYS.CATEGORY, categorySlug);
    } catch (error) {
      console.error('Ошибка сохранения категории:', error);
    }
  },

  //Получить категорию из localStorage
  getCategory() {
    try {
      return localStorage.getItem(STORAGE_KEYS.CATEGORY);
    } catch (error) {
      console.error('Ошибка чтения категории:', error);
      return null;
    }
  },

  //Очистить категорию
  clearCategory() {
    try {
      localStorage.removeItem(STORAGE_KEYS.CATEGORY);
    } catch (error) {
      console.error('Ошибка очистки категории:', error);
    }
  },
};